import React from 'react'
import { PrimaryButtonView } from 'components'

export default ({ isLoggingIn }) => (
  <PrimaryButtonView
    disabled={isLoggingIn}
    label={isLoggingIn ? 'SIGNING UP...' : 'SIGN UP'}
  />
)
